import { CampaignList } from './CampaignList';
import { PageHeader } from '../../components/layout/PageHeader';

export function CampaignsPage() {
  return (
    <div>
      <PageHeader title="Campaigns" description="Reusable ad campaign templates, per brand." />
      <CampaignList />
    </div>
  );
}
